import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { ReactComponent as PlayIcon } from '../../../../assets/ic_play.svg';

interface ISetupJourneyBoxProps {
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  progress?: number;
  no: number;
  title: string;
  description: string;
  enabled: boolean;
  onButtonPress?: () => void;
}

export default function SetupJourneyBox({
  Icon,
  progress,
  no,
  title,
  description,
  enabled,
  onButtonPress,
}: ISetupJourneyBoxProps) {
  return (
    <div className={`flex flex-col ${no > 1 ? 'mt-16' : 'mt-8'}`}>
      <div className="flex relative ml-5 w-16 aspect-square max-md:ml-2.5 shadow-lg justify-center items-center rounded-full z-1">
        <div
          className={`flex w-14 aspect-square rounded-full ${
            enabled ? 'bg-[#0B4048]' : 'bg-[#c4c4c4]'
          } justify-center items-center`}
        >
          <Icon className="w-8 aspect-square fill-white" />
        </div>

        <div className="absolute left-0 top-0 w-16 aspect-square">
          <CircularProgressbar
            value={progress ?? 0}
            strokeWidth={15}
            styles={buildStyles({
              // Colors
              pathColor: enabled ? '#06B1AB' : '#CACACA',
              trailColor: enabled ? '#C2DFDD' : '#DADADA',
            })}
          />
        </div>
      </div>

      <div
        className={`flex items-start px-9 py-6 w-full rounded-3xl ${
          enabled
            ? 'bg-white border border-solid shadow-md border-stone-300'
            : 'bg-[#f6f6f6]'
        } max-md:flex-wrap max-md:px-5 max-md:max-w-full mt-[-15px]`}
      >
        <div
          className={`mt-6 text-2xl font-semibold ${
            enabled ? 'text-[#047B84]' : 'text-[#C4C4C4]'
          }`}
        >
          {no}
        </div>
        <div className="flex flex-1 flex-col mt-4 mx-12 max-md:max-w-full">
          <div
            className={`text-2xl font-semibold ${
              enabled ? 'text-black' : 'text-[#9F9F9F]'
            } max-md:max-w-full`}
          >
            {title}
          </div>
          <div
            className={`mt-2 text-xl leading-8 ${
              enabled ? 'text-zinc-500' : 'text-[#9F9F9F]'
            } max-md:max-w-full whitespace-pre-line`}
          >
            {description}
          </div>
        </div>
        {enabled && (
          <button
            className="flex gap-2 justify-center items-center py-1.5 px-6 ph-8 text-lg font-medium leading-6 text-center text-white whitespace-nowrap bg-cyan-700 rounded-2xl max-md:px-5"
            onClick={onButtonPress}
          >
            <div>Start</div>
            <PlayIcon className="shrink-0 w-6 aspect-square" />
          </button>
        )}
      </div>
    </div>
  );
}
